module.exports = __webpack_public_path__ + "media/assets/images/events/20210922/event_image_share-143499cf279c3a10745cc97a3959188a.png";